// authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface LoginState {
    email: string;
    phoneNo: string;
    wizardPageNumber: number;

}



const initialState: LoginState = {
    email: '',
    phoneNo: '',
    wizardPageNumber: 1,

};

// Create your auth slice
const ResetPasswordReducer = createSlice({
    name: 'resetPassword',
    initialState,
    reducers: {
        setEmail: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        setPhoneNo: (state, action: PayloadAction<string>) => {
            state.phoneNo = action.payload;
        },
       
        setResetPasswordWizardPageNumber: (state, action: PayloadAction<number>) => {
            state.wizardPageNumber = action.payload;
        },

    },
});

export const { setEmail, setResetPasswordWizardPageNumber ,setPhoneNo} = ResetPasswordReducer.actions;
export default ResetPasswordReducer.reducer;
